module.exports = __webpack_public_path__ + "static/img/banner1.ec250e2e.png";